import React, { useEffect } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Table, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { listPaymentTypes, deletePaymentType } from '../actions/paymentActions'

function PaymentTypeListScreen() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const paymentTypeList = useSelector(state => state.paymentTypeList)
    const { loading, error, paymentTypes } = paymentTypeList

    const paymentTypeDelete = useSelector(state => state.paymentTypeDelete)
    const { success: successDelete } = paymentTypeDelete

    const userLogin = useSelector(state => state.userLogin)
    const { userInfo } = userLogin

    useEffect(() => {
        if (!userInfo || !userInfo.isAdmin) {
            navigate('/login')
        } else {
            dispatch(listPaymentTypes())
        }
    }, [dispatch, navigate, userInfo, successDelete])

    const deleteHandler = (id) => {
        if (window.confirm('Delete this payment type?')) {
            dispatch(deletePaymentType(id))
        }
    }

    return (
        <div>
            <Row className='align-items-center mb-3'>
                <Col><h2>Payment Types</h2></Col>
                <Col className='text-end'>
                    <LinkContainer to='/admin/payment-types/create'>
                        <Button variant='dark' size='sm'>
                            <i className='fa-solid fa-plus me-1'></i> Add Payment Type
                        </Button>
                    </LinkContainer>
                </Col>
            </Row>

            {loading ? <Loader /> : error ? <Message variant='danger'>{error}</Message> : paymentTypes.length === 0 ? (
                <Message variant='info'>No records found. <LinkContainer to='/admin/payment-types/create'><a href='#'>Add one now.</a></LinkContainer></Message>
            ) : (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Instructions</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {paymentTypes.map(pt => (
                            <tr key={pt.id}>
                                <td>{pt.id}</td>
                                <td>{pt.name}</td>
                                <td>{pt.instructions || '—'}</td>
                                <td className='text-end'>
                                    <LinkContainer to={`/admin/payment-types/${pt.id}/edit`}>
                                        <Button variant='outline-secondary' size='sm' className='me-2'>
                                            <i className='fa-solid fa-pen'></i>
                                        </Button>
                                    </LinkContainer>
                                    <Button variant='outline-danger' size='sm' onClick={() => deleteHandler(pt.id)}>
                                        <i className='fa-solid fa-trash'></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    )
}

export default PaymentTypeListScreen
